import {
  SET_DESTINATION_PATH,
  GET_OPERATOR,
  SAVE_PLAN_INFOS,
  GET_HEALTH_INSURANCE_PLANS,
} from "./selectHealthInsuranceConstants";
import { HealthInsurancePlanProps } from "../selectHealthInsuranceInterface";

interface SelectHealthInsuranceState {
  getDestinationPath: string;
  listOperators: any[];
  planInfos: any;
  healthInsurancePlans: HealthInsurancePlanProps[];
}

const INITIAL_STATE: SelectHealthInsuranceState = {
  getDestinationPath: "",
  listOperators: [],
  planInfos: [],
  healthInsurancePlans: [],
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (
  state = INITIAL_STATE,
  action: any
): SelectHealthInsuranceState => {
  switch (action.type) {
    case SET_DESTINATION_PATH:
      var _getDestinationPath;
      _getDestinationPath = action.data;

      return {
        ...state,
        getDestinationPath: _getDestinationPath,
      };

    case GET_OPERATOR:
      var _listOperators;
      _listOperators = action.data;
      return {
        ...state,
        listOperators: _listOperators,
      };

    case SAVE_PLAN_INFOS:
      var _planInfos;
      _planInfos = action.data;
      const session = JSON.stringify(_planInfos);
      localStorage.setItem("planInfos", session);
      return {
        ...state,
        planInfos: _planInfos,
      };

    case GET_HEALTH_INSURANCE_PLANS:
      var _healthInsurancePlans: HealthInsurancePlanProps[];
      _healthInsurancePlans = action.data;
      return {
        ...state,
        healthInsurancePlans: _healthInsurancePlans,
      };
  }

  return state;
};
